import React from "react";
import UserDetail from "./user-detail";
import { useAppDispatch, useAppSelector } from "../../../redux";
import "./MyAccount.scss";

const MyAccount = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="my-account-container">
      <h1 className="page-title">My Account</h1>
      <UserDetail />
    </div>
  );
};

export default MyAccount;
